import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './i18n/en.json';

// the translations
const resources = {
  en: {
    translation: en,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en',
    defaultNS: 'common',

    // keySeparator: false, // we do not use keys in form messages.welcome
    // debug: true,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
